import { LangMessages, Language, languages, Messages } from './utils';

export function getMessages(language: Language): Record<string, string> {
  return messages[language];
}

const _messages: Record<string, LangMessages> = {};
languages.forEach((lang: Language): void => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const m = require(`../../translation/${lang}.json`);
    _messages[lang] = m as LangMessages;
  } catch (e) {
  }
});

export const messages: Record<Language, Record<string, string>> = _messages as Messages;
